import { computed, ref } from 'vue'
import { defineStore } from 'pinia'

export const RECOMMENDED_GAME_QUERY = 'recommended'

export function withRecommendedGameQuery(location) {
  return { ...location, query: { ...location.query, [RECOMMENDED_GAME_QUERY]: '1' } }
}

export const useGamesStore = defineStore('games', () => {
  const fastCashbackGameIds = ref(new Set())
  function isFastCashbackGame(id) {
    return fastCashbackGameIds.value.has(id)
  }
  function updateFastCashbackGameIds(payload) {
    fastCashbackGameIds.value = new Set(payload)
  }

  const competitionsGameIds = ref(new Set())
  function isCompetitionGame(id) {
    return competitionsGameIds.value.has(id)
  }
  function updateCompetitionsGameIds(payload) {
    competitionsGameIds.value = new Set(payload)
  }

  const dgaTableIds = ref(new Set())
  function isDgaTable(id) {
    return dgaTableIds.value.has(id)
  }
  function updateDgaTableIds(payload) {
    dgaTableIds.value = new Set(payload)
  }

  const favoritesIds = ref(new Set())
  const favoritesCount = ref(0)
  const hasFavorites = computed(() => favoritesCount.value > 0)
  function updateFavorites(list) {
    if (Array.isArray(list)) {
      list.forEach((item) => favoritesIds.value.add(item))
    }
  }

  function updateFavoritesCount(count) {
    favoritesCount.value = count
  }

  function addFavorite(id) {
    const had = favoritesIds.value.has(id)
    favoritesIds.value.add(id)
    if (!had) {
      favoritesCount.value += 1
    }
  }

  function removeFavorite(id) {
    const had = favoritesIds.value.has(id)
    favoritesIds.value.delete(id)
    if (had && favoritesCount.value > 0) {
      favoritesCount.value -= 1
    }
  }

  function isFavorite(id) {
    return favoritesIds.value.has(id)
  }

  const recommendedGameSlug = ref(null)
  function setRecommendedGameSlug(slug) {
    recommendedGameSlug.value = slug ?? null
  }

  return {
    // refs
    recommendedGameSlug,
    fastCashbackGameIds,
    competitionsGameIds,
    dgaTableIds,
    favoritesIds,
    // computed
    favoritesCount,
    hasFavorites,
    //functions
    isDgaTable,
    updateDgaTableIds,
    isFastCashbackGame,
    updateFastCashbackGameIds,
    isCompetitionGame,
    updateCompetitionsGameIds,
    updateFavorites,
    addFavorite,
    removeFavorite,
    isFavorite,
    updateFavoritesCount,
    setRecommendedGameSlug,
  }
})
